<template>
    <div class="sm:col-span-12">
        <div>
            <FormLabel :value="$t('messages.number')" for="number" />
            <FormInput
                id="number"
                v-model.trim="form.number"
                name="number"
                @keypress.enter.prevent
                :placeholder="$t('messages.number')"
                type="number"
                required
                step="any"
                class="mt-1 w-40"
            />
            <FormError :value="errors[`options.number`]" class="mt-2" />

            <div class="mt-3 w-40">
                <FormLabel :value="$t('messages.tolerance')" for="tolerance" />
                <FormInput
                    id="tolerance"
                    v-model.trim="form.tolerance"
                    name="tolerance"
                    @keypress.enter.prevent
                    :placeholder="$t('messages.tolerance')"
                    type="number"
                    required
                    min="0"
                    step="any"
                    class="mt-3 w-40"
                />
                <FormError :value="errors[`options.tolerance`]" class="mt-2" />
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'QuestionMathNumberWithToleranceOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    mounted() {
        let defaultOptions = {
            number: '',
            tolerance: '0',
        };
        if (!this.form.hasOwnProperty('number')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
